class FileService {
  static getImageUrl = (fileId: string | undefined) => {
    return fileId
      ? (process.env.REACT_APP_API_URL ?? 'http://localhost:44380') + `/api/v1/Files/${fileId}/Data`
      : '/image-placeholder.svg';
  };
}

export default FileService;
